'use strict';

import React, { useState, useEffect } from 'react';
import Urls from '../../../definitions/Urls';
import {Link, withRouter} from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import OTButton from '../../../components/tag/OTButton';
import OTButtonGroup from '../../../components/tag/OTButtonGroup';
import Span from '../../../components/tag/Span';
import { OTLink } from '../../../components/tag/OTLink';
import NotificationWithIcon from '../../../components/NotificationWithIcon';
import Logger from '../../../utils/Logger';
import { getTime } from '../../../utils/TimeUtils';
import {
  getDepartmentDisplay,
  mapVisibleQuestionnaires,
  isRemoteVisit,
  getVideoConferenceLink,
} from '../../../utils/TimelineUtils';
import { getLogo } from '../../../utils/LogoUtils';
import QLink from './QLink';
import { notEmpty } from '../../../utils/Functions';
import {
  TYPE_IMAGING_MAGNET,
  TYPE_IMAGING_TOMOGRAPHY,
} from '../../../definitions/TimelineItems';
import Instructions from './Instructions';
import VideoConferenceLink from './VideoConferenceLink';

let { id: module_id } = module;
const logger = new Logger(module_id);

const TimelineNotification = (props) => {
  const {
    intl,
    data,
    qIsFetching,
    description,
    linkkipalvelu,
    canBeRescheduled,
    rescheduleTimelineReservation,
    approveTimelineReservation,
  } = props;

  const [disabled, setDisabled] = useState(false);
  const [unitLogo, setUnitLogo] = useState(null);
  const [isLogo, setIsLogo] = useState(false);
  const [visibleQuestionnaires, setVisibleQuestionnaires] = useState(null); // TODO: Remove
  const [isKidneyDept, setIsKidneyDept] = useState(null); // TODO: Remove
  const [departmentDisplay, setDepartmentDisplay] = useState(null); // TODO: Remove
  const [date, setDate] = useState(null); // TODO: Remove
  const [time, setTime] = useState(null); // TODO: Remove
  const [notificationButtons, setNotificationButtons] = useState([]); // TODO: Remove
  const [notificationDate] = useState(getTime(data.date)); // TODO: Remove

  useEffect(() => {
    setDepartmentDisplay(getDepartmentDisplay(data.department).toLowerCase());
    setDate(notificationDate.format('DD.MM.YYYY'));
    setTime(notificationDate.format('HH.mm'));
    setVisibleQuestionnaires(mapVisibleQuestionnaires(data));
    data.department &&
      setIsKidneyDept(new RegExp(/\(MUNP\)/).test(data.department));
  }, []);

  const handleOnClick = () => {
    setDisabled(true);
    approveTimelineReservation(data.id);
  };

  useEffect(() => {
    if (isRemoteVisit(data)) {
      setNotificationButtons([
        ...notificationButtons,
        <OTButton
          key="approve"
          message="show.info"
          onClick={handleOnClick}
          disabled={disabled}
        />,
      ]);
    } else {
      setNotificationButtons(
        ...notificationButtons,
        <OTButton
          key="approve"
          message="show.info"
          onClick={handleOnClick}
          disabled={disabled}
        />
      );
    }

    /*if (canBeRescheduled) {
     notificationButtons.push(
        <OTButton
          key="decline"
          onClick={() =>
            rescheduleTimelineReservation(id)}
        >
          <FormattedMessage id="move.time"/>
        </OTButton>
      );
    } */
  }, []);

  useEffect(() => {
    let logoFromLinkkipalvelu =
      linkkipalvelu.Logot && linkkipalvelu.Logot[data.oid];
    let linkkipalveluUnitLogo = null;
    if (
      logoFromLinkkipalvelu &&
      logoFromLinkkipalvelu !== 'fetching' &&
      logoFromLinkkipalvelu !== 'error' &&
      logoFromLinkkipalvelu[0]
    ) {
      let logoAttr = getLogo(logoFromLinkkipalvelu[0].toString());
      if (logoAttr) {
        linkkipalveluUnitLogo = (
          <img
            className="ot-notification__logo"
            alt={intl.formatMessage({ id: logoAttr.altTextId })}
            src={logoAttr.logoSrc}
          />
        );
        setUnitLogo(linkkipalveluUnitLogo);
      }
    }

    setIsLogo(!!linkkipalveluUnitLogo);
  }, [linkkipalvelu]);

  const getDescription = () => {
    if (isRemoteVisit(data)) {
      return (
          <FormattedMessage id={`${module_id}.remote.description`} />
      )
    } else if (data?.config?.type === 'imaging') {
      if (data?.config?.subtype.includes('ISOTOPETREATMENT')) {
        return (
            <FormattedMessage id={`${module_id}.imaging.isotope.description`} />
        )
      }
    }
    return (
        <FormattedMessage id={`${module_id}.default.description`} />
    )
  }

  return (
    <NotificationWithIcon
      titleIntl={{ id: `${module_id}.title` }}
      icon={{ type: 'fa', name: 'icon-calendar' }}
      logo={unitLogo}
      dateString={notificationDate.format('DD.MM.YYYY')}
      description={
        <>
          <FormattedMessage id={`${module_id}.initial.description`} values={{
            br: <br />
          }}/>
          {getDescription()}
        {/*<FormattedMessage
            id={description}
            values={{
              date: date,
              time: time,
              department: departmentDisplay,
              br: <br />,
              strong: (chunks) => <strong>{chunks}</strong>,
              span: (chunks) => <span className="department">{chunks}</span>,
              a: (txt) => {
                if (isRemoteVisit(data)) {
                  return (
                    <>
                      <a target={'_blank'} href={'/videovastaanoton-ohjeet'}>
                        {txt}
                      </a>
                      <br />
                      <br />
                      <p>
                        <FormattedMessage
                          id={
                            'video.conference.microphone.permission.instructions'
                          }
                        />
                        <br />
                        <FormattedMessage
                          id={'video.conference.microphone.mute.instructions'}
                        />
                      </p>
                    </>
                  );
                }
                return <a href={''}>{txt}</a>;
              },
            }}
          />*/}
          {/*isRemoteVisit(data) ? (
            <div className={'card-link link__video-conference'}>
              <FormattedMessage id={'go.to.video.conference'}>
                {(txt) => (
                  <VideoConferenceLink
                    isExternal
                    onClick={getVideoConferenceLink}
                  >
                    {txt}
                  </VideoConferenceLink>
                )}
              </FormattedMessage>
            </div>
          ) : null*/}
          {/*data?.config?.type === 'imaging' &&
          Array.isArray(data?.config?.instructions) ? (
            <Instructions instructions={data?.config?.instructions} />
          ) : null*/}

          {/*canBeRescheduled && (
            <Span>
              <i className="icon-calendar" />{' '}
              <a
                className="ot-notification__link ot-notification__link--small"
                onClick={() => rescheduleTimelineReservation(data.id)}
              >
                <FormattedMessage id="move.time" />
              </a>
            </Span>
          )*/}
          {/*notEmpty(visibleQuestionnaires) && (
            <>
              <Span>
                <FormattedMessage id={`${module_id}.related.questionnaires`} />
              </Span>
              <Span>
                <ul>
                  {visibleQuestionnaires.map((q) => (
                    <QLink
                      key={q.id}
                      qIsFetching={qIsFetching}
                      questionnaire={q}
                    />
                  ))}
                </ul>
              </Span>
            </>
          )*/}
          {/*isKidneyDept && (
            <Span className="row-fluid">
              <Span>
                <i className="icon-info-sign" />{' '}
                <OTLink
                  className="ot-notification__link ot-notification__link--small"
                  target="_blank"
                  link={Urls.careUnitdetails}
                  isExternal
                >
                  <FormattedMessage id={`${module_id}.MUNP.careUnitDetails`} />
                </OTLink>
              </Span>
              <Span>
                <i className="icon-list-ul" />{' '}
                <Link
                  to="/questionnaires"
                  className="ot-notification__link ot-notification__link--small"
                >
                  <FormattedMessage id={`${module_id}.MUNP.questionnaires`} />
                </Link>
              </Span>
              <Span>
                <i className="icon-file" />{' '}
                <OTLink
                  className="ot-notification__link ot-notification__link--small"
                  target="_blank"
                  link={Urls.patientFees}
                  isExternal
                >
                  <FormattedMessage id={`${module_id}.MUNP.patientFees`} />
                </OTLink>
              </Span>
            </Span>
          )*/}
        </>
      }
      actions={
        <>
          <Span len={'3'} sm-len="12">
            <OTButtonGroup
              fullWidth={true}
              type="big"
              expectedCount={isKidneyDept && '1'}
              collapseOnMobile
            >
              {notificationButtons}
            </OTButtonGroup>
          </Span>
          {/*isKidneyDept && (
            <Span len="9">
              <p
                className="ot-notification__description--small"
                style={
                  isKidneyDept
                    ? {
                        color: 'black',
                        marginLeft: '10px',
                        display: 'inline-block',
                      }
                    : { marginBottom: '10px' }
                }
              >
                <FormattedMessage
                  id={`${module_id}.MUNP.attention`}
                  values={{
                    i: (chunks) => <i>{chunks}</i>,
                    br: <br />,
                  }}
                />
              </p>
            </Span>
          )*/}
          {isLogo && (
            <Span len="9" sm-len={'12'}>
              {unitLogo}
            </Span>
          )}
        </>
      }
    />
  );
};

export default injectIntl(TimelineNotification);
